module.exports = __webpack_public_path__ + "static/media/b-logo.1701417a.svg";